import React from 'react'

export default function UploadDocs() {
  const onSubmit = (e) => { e.preventDefault(); alert('Upload flow — implement signed S3 upload') }
  return (
    <div className="container">
      <section className="card" style={{maxWidth:720, margin:'0 auto'}}>
        <h2 className="h2">Upload documents</h2>
        <p className="kv">Upload receipts, bank statements, or invoices. Files will be securely stored and shared with your bookkeeper.</p>

        <form onSubmit={onSubmit} style={{display:'grid', gap:12, marginTop:12}}>
          <label className="kv">Select document type</label>
          <select style={{padding:12, borderRadius:8, border:'1px solid #eef6ff'}}>
            <option>Receipt</option><option>Bank statement</option><option>Invoice</option><option>Other</option>
          </select>

          <label className="kv">Choose file</label>
          <input type="file" accept=".pdf,.png,.jpg" />

          <label className="kv">Optional note</label>
          <textarea placeholder="Add context for your bookkeeper" rows="4" style={{padding:12, borderRadius:8, border:'1px solid #eef6ff'}} />

          <button className="btn primary" type="submit">Upload</button>
        </form>
      </section>
    </div>
  )
}
